import ATMPageHeading from "src/components/UI/atoms/ATMPageHeading/ATMPageHeading";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import { formatedDateTimeIntoIst } from "src/utils/formUtils/dateTimeFormate";
type Props = {
  columns: columnTypes[];
  rows: any[];
  itemsGoal: any,
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const ViewGoal = ({
  columns,
  rows,
  itemsGoal,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const firstLetter = itemsGoal?.name?.charAt(0).toUpperCase();
  return (
    <>
      <div className="flex flex-col h-full">
        {/* Page Header */}
        <div className='px-4 my-6'>
          <ATMPageHeading>Goal Details :-  </ATMPageHeading>
          <div className='flex justify-between p-2 mt-3 border rounded-md text-md '>
            <div className='relative flex flex-col items-start'>
              <div className='flex items-center'>
                <span className='absolute top-0 bottom-0 left-0 flex items-center p-5 text-lg font-bold rounded bg-sky-50'>{firstLetter}</span>
                <div className='px-6 ml-10'>
                  <div className='font-semibold capitalize'>{itemsGoal?.name}</div>
                  <div className='flex text-grey-500'>
                    <span className=''>{itemsGoal?.goalCategoryName}</span>
                    <span className='px-2'>|</span>
                    <span className=''>{formatedDateTimeIntoIst(itemsGoal.deadline, "DD MMM yyyy")} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="px-4">
          <ATMPageHeading>Achievements</ATMPageHeading></div>
        <div className="flex flex-col flex-1 px-2 py-3 overflow-auto md:px-4">
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[50px]"}
            isLoading={isTableLoading}
          />
        </div>

        <div className="p-2 py-2 md:p-4">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
    </>
  );
};

export default ViewGoal;
